<template>
  <div>
    <!-- Full calendar mount point -->
    <div class="calendar-container">
      <div
        id="event-popup"
        :class="{
          'fix-width': true,
          'd-none': currentViewedEvent === null,
          'sticky-stick': isSticky
        }">

        <button
          class="close-popup d-block d-md-none"
          @click="resetPopup()">

          <i class="fas fa-times"></i>
        </button>

        <grid-item
          class="fix-width"
          @editMpe="editMpe"
          @removeMpe="removeMpe"
          @duplicate="duplicate"
          displayType="grid"
          :dataLoading="isDataLoading"
          :item="getPopupMpe"
          :variant="campaignPreviewItems ? 'basic' : 'detailed'" />

      </div>

      <div id='f_calendar' />
    </div>
  </div>
</template>

<script>
import GridItem from '@/components/service/campaignManager/mpeGrid/GridItem'
import ch from './calendarHelpers'

import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'
import localStorageHelper from '@/assets/modules/localStorageHelper'

import 'fullcalendar';
import moment from 'moment'

let { short } = localStorageHelper.getLocale()

const ACTIVE_STATUSES = {
  CAMPAIGNS: {
    active: true
  },

  QUICK_POSTS: {
    publishQueued: true,
    published: true,
    publishDeferred: true,
  }
}

const CAMPAIGN_DRAFT_STATUSES = {
  draft: true
}

export default {
  data () {
    return {
      popupMpeId: null,
      
      fullCalendarObj: null,
      fullCalendarContainer: '.calendar-container',
      eventPopupContainer: '#event-popup',

      today: this.viewedMonth || moment(),
      style: this.calendarStyle,
      currentViewedEvent: null
    }
  },

  methods: {
    /**
     * Detatches MPE editpr popup from it's event
     */
    detachPopup () {
      $(this.eventPopupContainer)
        .detach()
        .appendTo($(this.fullCalendarContainer))

    },

    /**
     * Resets editor popup by reseting event id and detatching it
     */
    resetPopup () {
      this.currentViewedEvent = null
      this.popupMpeId = null  
      this.detachPopup()
    },

    /**
     * Reataches popup by changing it's parent node
     * @param {String} newNode DOM selector
     */
    reatachPopup (newNode) {
      let newP = $(newNode)
      $(this.eventPopupContainer)
        .detach()
        .appendTo(newP)

    },

    /**
     * Requests event editor for given event
     * @param {Object} e Event
     */
    editMpe (e) {
      this.$emit('editMpe', e)
    },

    /**
     * Requests event duplication.
     * @param {Object} e Event
     */
    duplicate (e) {
      this.$emit('duplicate', e)
    },

    /**
     * Requests event removal
     * @param {Object} e Event
     */
    removeMpe (e) {
      this.$emit('removeMpe', e)
    },

    /**
     * Rerenders all events
     */
    reRenderEvents () {
      this.fullCalendarObj.fullCalendar('refetchEvents')
    },

    /**
     * Changes calendar's viewed date
     * @param {Object} nd date
     */
    changeMonth (nd) {
      this.detachPopup()

      this.fullCalendarObj.fullCalendar('gotoDate', moment(nd).format('YYYY-MM-DD'))
      this.reRenderEvents(this.events)
    },

    /**
     * Changes calendar view
     * @param {String} view New calendar view
     */
    changeCalendarView (view) {
      this.resetPopup()
      this.style = view

      let calendarOptions = this.fullCalendarObj
        .fullCalendar('getView')
        .options

      // Change the calendar style and head date format.

      // Set new options
      this.fullCalendarObj
        .fullCalendar('changeView', this.style)
    },

    /**
     * Mark today on calendar
     */
    markToday () {
      // If months match...
      if (moment(this.viewedMonth).format('M') === moment().format('M')) {
        let dayNumber = moment().format('d')
        $(`.fc-month-view .fc-day-header:nth-child(${parseInt(dayNumber)})`).css({ 'color': '#7AC143' })
      } else {
        $(`.fc-month-view .fc-day-header`).css({ 'color': '#353635' })
      }
    },

    /**
     * Offsets calendar's popup so it won't overflow the viewport
     * @param {Object} jsEvent
     */
    getCalendarOffsets (jsEvent, view) {
      // Popup params...
      let popupDimensions = { width: 200, height: 350 }
      let popupDisplacement = { x: 30, y: 10  }

      // On mobile view push popup closer to event
      if (this.$store.getters.isMobileView) { popupDisplacement.x = 10 }

      let calendarRect = view.el[0].getBoundingClientRect()
      let elementRect = jsEvent.target.getBoundingClientRect()

      // Event's position
      let { left: eventOffsetX, top: eventOffsetY } = elementRect

      // Popup's possible clipped edges -- top and left can't clip, because no event is outside calendar,
      // and popup is relative to event's position
      let popupPositionRight = eventOffsetX + popupDisplacement.x + popupDimensions.width
      let popupPositionBottom = eventOffsetY + popupDisplacement.y + popupDimensions.height

      // Adjust x displacement
      if (popupPositionRight > calendarRect.right) {
        popupDisplacement.x = calendarRect.right - popupPositionRight
      }

      // Adjust y displacement
      if (popupPositionBottom > calendarRect.bottom) {
        popupDisplacement.y = calendarRect.bottom - popupPositionBottom
      }

      return {
        popupOffsetX: popupDisplacement.x,
        popupOffsetY: popupDisplacement.y
      }
    },

    /**
     * Offsets the popup
     * @param {Number} offX X offset
     * @param {Number} offY Y offset
     * @param {Object} ref Dom reference
     * 
     */
    offsetPopup (offX, offY, ref) {
      // Offset away from the edges if needed.
      ref.css({
        'left': offX,
        'top': offY
      })
    },

    /**
     * Gives valid date range for calendar
     * @returns {Object}
     */
    getValidRange () {
      if (!this.validRange) return {}

      // Check if range is not same
      let { start, end } = this.validRange
      start = (start) ? moment(start) : null
      end = (end) ? moment(end).add(1, 'day').startOf('day') : null

      return {
        start,
        end
      }
    },

    /**
     * Shows calendar event popup
     * @param {Object} calEvent Calendar's event
     * @param {Object} jsEvent
     * @param {Object} view Calendar ref
     */
    showEventPopup (calEvent, jsEvent, view) {
      // Change zIndexes so events don't overlay the popup
      // Push all back
      $('.fc-content-col').css({
        'z-index': 1
      })

      // Push current forth
      $(jsEvent.currentTarget.parentNode.parentNode).css({
        'z-index': 100
      })

      this.popupMpeId = calEvent.data.uuid

      // Find the new parent for the popup.
      // The calendar has it's event listeners on multiple elements
      // so we need to get to the higher common element.
      let newP = jsEvent.target

      // For month go further in the DOM, becouse we need to change the rows z-index as well...
      let match = (this.style === 'month')
        ? 'fc-row' // 'fc-day-grid-event'
        : 'fc-time-grid-event'

      // This is going to have the new parent node.
      let newPNode = null

      // If hover over icon - icon has a wrapper around it as well!
      if (newP.localName == 'svg') newP = newP.parentNode.parentNode

      while ((newP.className || '')
        .split(' ')
        .findIndex(e => e === match) == -1) {

        // Becouse event's listener gets propagaded to the popup...
        if (newP.id === 'event-popup') {
          return
        }

        // For month, temporary store the new parent node.
        if (newP.className
          .split(' ')
          .findIndex(e => e === 'fc-day-grid-event') !== -1) {
          
          newPNode = newP
        }

        newP = newP.parentNode
      }

      // Push it to the top, and the rest to the bottom.
      $(`.${match}`).css({
        'z-index': 1
      });

      if (this.style === 'month') {
        newP.style['z-index'] = 10000
        newP = newPNode
      } else {
        newP.style['z-index'] = 10000
      }

      // Change parent.
      this.reatachPopup(newP)
      this.currentViewedEvent = calEvent

      let {popupOffsetX, popupOffsetY} = this.getCalendarOffsets(jsEvent, view)
      this.offsetPopup(popupOffsetX, popupOffsetY, $(this.eventPopupContainer))
    },

    /**
     * Renders calendar
     */
    renderCalendar () {
      let self = this

      $(function() {
        self.fullCalendarObj.fullCalendar({
          defaultView: self.style,
          editable: true,
          minTime: "01:00:00",
          maxTime: "25:00:00",
          slotDuration: "01:00:00",
          slotLabelFormat: ['H'],
          columnFormat: ['ddd\nDD'],
          timezone: 'local',
          locale: short,
          axisFormat: 'H:mm',
          defaultDate: moment(this.viewedMonth),
          header: self.getCalendarHeader,
          validRange: self.getValidRange,
          buttonText: self.buttonText,

          /**
           * Triggeres when view renderes
           */
          viewRender (view, element) {
            if (self.calendarStyle === view.name && self.useCalendarNavigation) {
              // Intervals are in UTC
              let { intervalStart: from, intervalEnd: to, intervalStart: id } = view
  
              from = moment.utc(from).toISOString()
              to = moment.utc(to).toISOString()
              id = moment.utc(id).toISOString()
              let date = {
                from,
                id,
                to
              }
              self.$emit('changeDate', date)
            }
          },

          /**
           * Event provider method
           */
          events: function( start, end, timezone, callback ) {
            callback(self.events)
          },

          // Marks todays date
          eventAfterAllRender: (e) => {
            self.markToday()
          },

          /**
           * Render function. Will use to add icons to calendar events
           * @param {Object} event Looked event
           * @param {DOMElement} element
           */
          eventRender: function(event, element) {
            let eventLabelParts = event.eventLabelParts || {}
            if (eventLabelParts.prepend) {
              element.find(".fc-title").prepend(`<span class="channel-icon mr-1">${eventLabelParts.prepend}</span>`);
            }

            if (eventLabelParts.append) {
              element.find(".fc-title").append(`<span class="channel-icon ml-1">${eventLabelParts.append}</span>`);
            }
          },

          // Updates event's schedule when user drops
          eventDrop (event, dayDelta, minuteDelta, allDay, revertFunc) {
            self.updateSchedule(event)
          },

          /**
           * Determines if event is allowed to be dropped at current spot
           * Gets called when ever hover over a cell
           * @param {Object} dropLocation Where the event would be dropped
           * @param {Object} draggedEvent
           */
          eventAllow (dropLocation, draggedEvent) {
            return self.determineIfEventIsAllowed(dropLocation, draggedEvent)
          },

          eventResize (event, delta, revertFunc) {
            // Will disable this for now.
            return
            self.updateSchedule(event)
          },

          eventDragStart () {
            // Detatch popup so it won't get lost
            self.resetPopup()
          },

          // Detach popup
          eventMouseout: function() {
            self.resetPopup()
          },

          // Popup editor
          eventMouseover: function(calEvent, jsEvent, view) {
            self.showEventPopup(calEvent, jsEvent, view)
          },

          eventClick: function(calEvent, jsEvent, view) {
            self.showEventPopup(calEvent, jsEvent, view)
          }
        })

        self.changeMonth(self.viewedMonth)
      })
    },

    /**
     * Gives mpe based on searched id
     * @param {String} id Searched mpe's ID
     * @returns {Object}
     */
    getMpeById (id) {
      return this.mpes.filter(mpe => mpe.id === id)[0] || {}
    },

    /**
     * Emits an event to update schedule
     * @param {Object} event Calendar event that changed
     */
    updateSchedule (event) {
      // On drop send mutation to change events schedule
      let publishAt = event.start
      if (publishAt && publishAt._isAMomentObject) {
        publishAt = moment(publishAt).local().toISOString()
      }

      let expiresAt = event.end
      if (expiresAt && expiresAt._isAMomentObject) {
        expiresAt = moment(expiresAt).local().toISOString()
      }

      let schedule = {
        publishAt,
        expiresAt,
        id: event.data.uuid,
        type: event.data.type
      }

      this.$emit('setSchedule', schedule)
    },

    determineIfEventIsAllowed(dropLocation, draggedEvent) {
      let { start, data: { type, status, start: eventOriginalStart } } = draggedEvent
      eventOriginalStart = moment(eventOriginalStart)
      let now

      // Can't move mpe groups
      if (draggedEvent.data.fromType === 'Advertisable') {
        let message = 'Premikanje skupin objav ni mogoče.'
        nManager.nokNotification(this, message)
        return false
      }

      // Can't move campaign, because it ...
      if (resolver.isCampaign(type) && ACTIVE_STATUSES.CAMPAIGNS[status]) {
        // If campaign is in past
        now = moment()
        // ...is active in the past
        if (eventOriginalStart.isBefore(now)) {
          let message = 'Premikanje objav/kampanj v preteklosti ni mogoče.'
          nManager.nokNotification(this, message)
          return false
        } else {
          // ...it is active
          let message = 'Ker kampanje že poteka, je ne morete več prestaviti.'
          nManager.nokNotification(this, message)
          return false
        }
      }

      // Can't move posts in past
      if (!resolver.isCampaign(type)) {
        now = moment()
        if (eventOriginalStart.isBefore(now)) {
          let message = 'Premikanje objav/kampanj v preteklosti ni mogoče.'
          nManager.nokNotification(this, message)
          return false
        }
      }

      // Future events can't be placed in the past
      now = moment()
      // If event is not active and is in the past, use that date as now
      if (eventOriginalStart.isBefore(now)) now = eventOriginalStart
      if (start.isBefore(now)) {
        let message = 'Kampanje/izdelka ni mogoče prenesti v preteklost. Če ga ne želite obdržati v kampanji ga izbrišite.'
        nManager.nokNotification(this, message)
        return false
      }

      // It is valid
      nManager.removeNotification(this)
      return true
    }
  },

  computed: {
    events () {
      const rtr = []
      for (const mpe of this.mpes) {
        rtr.push(ch.calendarMeta(mpe, this.$store.getters, this.variant !== 'basic'))
      }
      return rtr
    },

    /**
     * Tells if data for current popup is loading
     * @returns {Boolean}
     */
    isDataLoading () {
      return !!this.removing[this.popupMpeId]
    },

    /**
     * Gives calendar's header tooltip actions
     * @returns {Object}
     */
    getCalendarHeader () {
      if (this.useCalendarNavigation) {
        return {
          left: '',
          center: 'prev title next',
          right: 'today'
        }
      }

      return {
        center: 'title',
        left: '',
        right: ''
      }
    },

    /**
     * Tells if popup has a sticky position
     * @returns {Boolean}
     */
    isSticky () {
      return this.calendarStyle === 'agendaWeek'
    },

    /**
     * Returns a MPE that we want to edit
     * @returns {Object}
     */
    getPopupMpe () {
      if (!this.popupMpeId) {
        return {}
      }
      return this.getMpeById(this.popupMpeId)
    }
  },

  /**
   * Inits calendar
   */
  mounted () {
    this.fullCalendarObj = $('#f_calendar')
    this.renderCalendar()
  },

  watch: {
    viewedMonth (newV, oldv) {
      this.changeMonth(newV)
    },
    newMonth (newV, oldV) {
      this.changeMonth(newV)
    },
    calendarStyle (newV, oldV) {
      this.changeCalendarView(newV)
    },
    mpes (newV, oldV) {
      this.reRenderEvents(this.events)
    },
    validRange: {
      handler: function (newValue) {
        // Update valid range limitation
        let limit = newValue || {}
        this.fullCalendarObj.fullCalendar('option', 'validRange', limit)
      },
      deep: true
    }
  },

  props: {
    removing: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    useCalendarNavigation: {
      type: Boolean,
      required: false,
      default: false
    },
    campaignPreviewItems: {
      type: Boolean,
      required: false,
      default: false
    },
    viewedMonth: {
      type: String,
      required: false,
      default: moment(new Date()).format()
    },
    calendarStyle: {
      type: String,
      required: false,
      default: null
    },
    mpes: {
      type: Array,
      required: false,
      default: () => []
    },
    validRange: {
      type: Object,
      required: false,
      default: () => { return {} }
    },

    buttonText: {
      type: Object,
      required: false,
      default: () => {
        return { today: 'Danes' }
      }
    },

    variant: {
      type: String,
      default: 'basic'
    }
  },

  components: {
    'grid-item': GridItem
  }

}
</script>

<style scoped>
#event-popup {
  position: absolute;
  z-index: 1000;
  top: 8px;
  left: 30px;
  padding: 0 15px;
}

#event-popup.sticky-stick {
  position: sticky;
}
.fix-width {
  min-width: 200px;
  max-width: 200px;
}

.close-popup {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 11px;
  margin-right: 2px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 30px;
  color: #FE2B41;
  font-weight: bold;
  background: none;
  border: none;
}

</style>


// WEBPACK FOOTER //
// src/components/standard/display/CampaignCalendar.vue?023f428a